export function clearAlertHistory(event) {
  const flash = document.getElementById("alert-container");
  if (flash) {
    flash.innerHTML = ""; // Removes the alert text before saving
  }
}
